import { render } from "./copyTransportToOthersModal.vue?vue&type=template&id=2824609a&scoped=true&ts=true"
import script from "./copyTransportToOthersModal.vue?vue&type=script&lang=ts"
export * from "./copyTransportToOthersModal.vue?vue&type=script&lang=ts"

import "./copyTransportToOthersModal.vue?vue&type=style&index=0&id=2824609a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2824609a"]])

export default __exports__